import {
  EditUserSensitiveInfoPasswordlessOtpInitiateRequest,
  PasswordlessInitiateRequest,
  UserAccountLoginPasswordlessOtpInitiateRequest,
} from '~domain/model/passwordless/passwordless-initiate-request';
import { PasswordlessValidationRequest } from '~domain/model/passwordless/passwordless-validation-request';
import { BaseClient, DEFAULT_JSON_API_HEADERS, Headers } from './base-client';
import { RequestErrorHandler } from './request-error-handlers/base-request-error-handler';

export interface InitiateResponse {
  token: string;
}

export interface ValidateResponse {
  accessToken: string;
}

export class PasswordlessClient extends BaseClient {
  constructor(baseUrl: string, headers: Headers = {}, requestErrorHandler?: RequestErrorHandler) {
    super(baseUrl, { ...DEFAULT_JSON_API_HEADERS, ...headers }, requestErrorHandler);
  }

  initiate(
    request: EditUserSensitiveInfoPasswordlessOtpInitiateRequest,
    accessToken: string,
  ): Promise<{ token: string }>;

  initiate(request: UserAccountLoginPasswordlessOtpInitiateRequest): Promise<InitiateResponse>;
  initiate(request: PasswordlessInitiateRequest, accessToken?: string): Promise<InitiateResponse> {
    if (accessToken) {
      this.api.setHeader('Authorization', `Bearer ${accessToken}`);
    }
    return this.create$<InitiateResponse>('initiate', request).toPromise<InitiateResponse>();
  }

  validate(request: PasswordlessValidationRequest): Promise<ValidateResponse> {
    return this.create$<ValidateResponse>('validate', request).toPromise<ValidateResponse>();
  }
}
